/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2020 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import FileApiBase from "bundle/api/FileApi";
import ServiceRegistry from "bundle/util/ServiceRegistry";
import Events from "bundle/constants/Events";
import IFrameMessageTypes from "common/constants/IFrameMessageTypes";

class FileApi extends FileApiBase {
    initialize() {
        this._appStore = ServiceRegistry.getService("AppStore");
        if (this._appStore.isInPreview) {
            const fileInfo = this._appStore.fileInfoList[0];
            this.getPagesRenditionByFileId(fileInfo.id);
            ServiceRegistry.getService("PerformanceService").setFileDownloadStartedOn();
            if (this._appStore.getActionConfig("preview").enableLinearization) {
                this.initForLinearization(fileInfo);
            } else {
                this.getFileContents(fileInfo.id);
            }
            ServiceRegistry.getService("EventsService").registerEventListener(
                Events.APP_RENDERING_START,
                () => {
                    const fileLoadingProgressCB = typeData => {
                        this.progressReceived(typeData.loaded, typeData.total);
                    };
                    ServiceRegistry.getService("MessagingService")
                        .listenForType(IFrameMessageTypes.FILE_LOADING_PROGRESS_DATA, fileLoadingProgressCB);
                },
            );
        }

        this.addProgressListener((loaded, total) => {
            this._appStore.setFileLoadingProgress(loaded, total);
        });
    }
}

export default FileApi;
